import {
  PassengerRead,
  usePassengersCreateMutation,
  usePassengersPartialUpdateMutation,
} from 'src/common/external/bambi-api/bambiApi';

export function usePassengerRepository() {
  const [createPassengerImpl] = usePassengersCreateMutation();
  const [updatePassengerImpl] = usePassengersPartialUpdateMutation();

  return {
    createPassenger: async (passenger: PassengerRead) => {
      return await createPassengerImpl({
        passenger,
      });
    },
    updatePassenger: async (patchedPassenger: PassengerRead) => {
      return await updatePassengerImpl({
        id: patchedPassenger.id || '',
        patchedPassenger,
      });
    },
  };
}
